import { render } from "./DTabItem.vue?vue&type=template&id=57e7fd78&scoped=true"
import script from "./DTabItem.vue?vue&type=script&lang=js"
export * from "./DTabItem.vue?vue&type=script&lang=js"

import "./DTabItem.vue?vue&type=style&index=0&id=57e7fd78&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57e7fd78"]])

export default __exports__